import { Dispatch } from "../../controller";
import { MeioPag } from "../../data.types";
import { Model,StateProps } from "../../model";

export type { MeioPag } from "../../data.types";

export interface MeioPagState extends StateProps<MeioPag> {
 
}

export interface MeioPagActions extends Dispatch<MeioPag> {

}

const model = new Model<MeioPag,MeioPagState>("meiopag");

const intialValueMeioPag:MeioPag = {
    ...model.getInitialValue(),
    type:"meiopag",
    descricao:"",
    gerar_titulo:false,
    perc_desc:0,
    obs:"",
    show_movel:false,
    ativo:true,
}

export const initialValueState:MeioPagState = {
    ...model.getInititalValueState(),
    row:intialValueMeioPag,
}


